import { Outlet } from '@tanstack/react-router';
import { array } from 'fp-ts';
import {
    ModalWrapper,
    NewModalBodyWrapper,
    OptimusProvider,
    OverlayedLoader,
    PageHeader,
    SpacedForwardSlash,
    useBreadcrumbs,
} from '@mews-commander/ui';
import { Container, Stack, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { useProductsOverviewEntries } from '../queries/useProductOverviewEntries';
import { useProductListActions } from '../hooks/useProductListActions';
import { ProductTable } from './table/ProductTable';
import { ProductSidePanelContextProvider } from './sidePanel/ProductSidePanelContext';

export const ProductListView = () => {
    const { data: tableData, isFetching } = useProductsOverviewEntries();
    const { actions, renderAllowanceDialog, renderProductDialog, renderProductCategoryDialog } =
        useProductListActions();

    const renderProductTables = () =>
        tableData.map(({ data, productCategoryId, productCategoryHierarchy, totalRowCount }) => {
            const categories = productCategoryHierarchy ? productCategoryHierarchy.slice(0, -1) : [];
            const categoryNames = `${categories.join(SpacedForwardSlash)}${UnicodeEntity.NoBreakSpace}${
                UnicodeEntity.ForwardSlash
            }`;

            return (
                <ProductTable
                    amountOfRows={totalRowCount}
                    data={data}
                    key={productCategoryId}
                    productCategoryId={productCategoryId}
                    productCategoryName={
                        productCategoryHierarchy
                            ? productCategoryHierarchy[productCategoryHierarchy.length - 1]
                            : 'Uncategorised'
                    }
                    subtitle={
                        <Typography textStyle="titleMediumStrong" as="div">
                            {productCategoryHierarchy && productCategoryId ? (
                                <>{productCategoryHierarchy[productCategoryHierarchy.length - 1]}</>
                            ) : (
                                lt('Uncategorised')
                            )}
                        </Typography>
                    }
                    title={
                        array.isEmpty(categories) ? undefined : (
                            <Typography textStyle="titleMedium" variant="secondary" as="div">
                                {categoryNames}
                            </Typography>
                        )
                    }
                />
            );
        });

    return (
        <OptimusProvider density="spacious">
            <OverlayedLoader show={isFetching} />
            <ModalWrapper>
                <PageHeader breadcrumbs={useBreadcrumbs()} actions={actions} />
                <NewModalBodyWrapper>
                    <Container padding={['200', '400']}>
                        <ProductSidePanelContextProvider>
                            <Outlet />
                            <Stack vertical spacing="300">
                                {renderProductTables()}
                            </Stack>
                        </ProductSidePanelContextProvider>
                    </Container>
                </NewModalBodyWrapper>
            </ModalWrapper>
            {renderAllowanceDialog()}
            {renderProductDialog()}
            {renderProductCategoryDialog()}
        </OptimusProvider>
    );
};
